import Quill from "quill";

var Embed = Quill.import("blots/embed");

class Svg extends Embed {
  callback = {};

  static create(value) {
    // Fillable, Raw, Content
    let temp = document.createElement('div');
    temp.innerHTML = value.content.trim();
    let svg = temp.querySelectorAll('svg')[0];
    const fillable = (svg.querySelectorAll('[fill]').length > 0) ? false : true;
    const raw = svg.outerHTML.replaceAll('\n', '').replaceAll('\t', '');
    svg.style.width = 'auto';
    svg.style.height = value.size;
    svg.style.fill = value.color;
    const content = svg.outerHTML;

    let node = super.create();
    node.setAttribute("data-ql-icon-fillable", fillable);
    node.setAttribute("data-ql-icon-name", value.name);
    node.setAttribute("data-ql-icon-size", value.size);
    node.setAttribute("data-ql-icon-color", value.color);
    node.setAttribute("data-ql-icon", raw);
    node.style.height = value.size;
    node.innerHTML = content;

    // // Click
    // node.addEventListener("click", function (e) {
    // //   e.preventDefault();
    // //   if (node.closest('.ql-editor').querySelector('.icon.active')) {
    // //     node.closest('.ql-editor').querySelector('.icon.active').classList.remove("active");
    // //   }
    // //   node.classList.add("active");
    //   // if (self.callback.onFocus) self.callback.onFocus(node);
    // }, false);

    return node;
  }
  static formats(domNode) {
    return {
      iconFillable: (domNode.getAttribute("data-ql-icon-fillable") === true || domNode.getAttribute("data-ql-icon-fillable") === 'true') ? true : false,
      iconName: domNode.getAttribute("data-ql-icon-name"),
      iconSize: domNode.getAttribute("data-ql-icon-size"),
      iconColor: domNode.getAttribute("data-ql-icon-color"),
      iconContent: domNode.getAttribute("data-ql-icon"),
    };
  }
  static value(domNode) {
    let size = domNode.getAttribute("data-ql-icon-size");
    return {
      name: domNode.getAttribute("data-ql-icon-name"),
      size: (size && !size.includes('px')) ? `${size}px` : size,
      color: domNode.getAttribute("data-ql-icon-color"),
      content: domNode.getAttribute("data-ql-icon"),
    };
  }
  static setCallback(callback) { // custom
    this.callback = callback;
  }
}

Svg.blotName = "icon";
Svg.className = "icon";
Svg.tagName = "SPAN";

export default Svg;